import React from 'react';
import {StaticQuery, graphql} from 'gatsby';
import PastPerformanceCalculator from './PastPerformanceCalculator';

const PastPerformanceStaticQueryWrapper = ({
    slot,
}) => {
    return (
        <StaticQuery
            query={
                graphql`
                query PastPerformanceData {
                    allPastPerformanceData {
                        nodes {
                            ReferenceFunds {
                                value
                                label
                                onceOffInvestmentTerms {
                                    value
                                    label
                                    fundPerformance
                                }
                                monthlyInvestmentTerms {
                                    value
                                    label
                                    fundPerformance
                                }
                            }
                            ReferenceInflation {
                                inflationType
                                value
                            }
                            CalculationDate
                        }
                    }
                }`
            }
            render={data => <PastPerformanceCalculator slot={slot} data={data}/>}
        />
    )
}

export default PastPerformanceStaticQueryWrapper;
